import React from 'react'

function DashboardMemberDetail() {
  return <>
   <div>Bu sayfa Private MemberDetail sayfası</div>
  </>
}

export default DashboardMemberDetail